import { useContext } from "react";
import { QuickActionsContext } from "../context/QuickActionsContext";

export const useQuickActions = () => {
  const context = useContext(QuickActionsContext);
  if (!context) {
    throw new Error("useQuickActions must be used within a QuickActionsProvider");
  }
  return context;
};
